export default __webpack_public_path__ + "static/media/Montserrat-Italic.593de7c5.woff2";